<template>
  <div
    class="v-input v-input__datetimepicker"
    :class="{
      'v-input--focus': focusOn,
      'v-input--hover': zindex,
      'v-input--is-dirty': isDirty,
      'v-input--is-disabled': disabled,
      'v-input__error--border': !!errors.has(newName),
    }"
    data-vv-value-path="model"
    :data-vv-as="label"
  >
    <label class="v-input__label" v-if="label" :data-vv-as="label">
      {{ label }}
    </label>
    <input
      :id="id || `${name}-picker`"
      class="v-input__field"
      v-model="model"
      type="text"
      @change="$emit('input', model)"
      v-validate="rules"
      ref="picker"
      @focus="show"
      @blur="hide(), checkModel($event)"
      @mouseover="focusUp"
      @mouseleave="focusDown"
      @input="$emit('input', model)"
      :name="name"
      :disabled="disabled"
      :autocomplete="autocomplete"
    />

    <input type="hidden" v-model="hidden" :name="name" />

    <div class="v-input__error" v-if="errors.has(newName)">
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
import field from "../mixins/field";
import $ from "jquery";
import "tempusdominus-bootstrap-4";

export default {
  data() {
    return {
      zindex: false,
      focusOn: false,
      autocomplete: this.isPrefillDisabled ? "off" : "on",
    };
  },
  computed: {
    hidden() {
      if (this.model && !this.timepicker) {
        let datetime = this.model.split(" ");
        let date = datetime[0].split("-");
        let time = "";

        if (datetime[1]) {
          time = " " + datetime[1];
        }
        return date[0] && date[1] && date[2]
          ? `${date[2]}-${date[1]}-${date[0]}${time}`
          : "";
      }else if(this.timepicker){
        return this.model;
      }

      return "";
    },
  },
  mounted() {
    moment.updateLocale("en", {
      week: { dow: 1 }, // Monday is the first day of the week
    });

    if (this.decades) {
      $(this.$refs.picker).datetimepicker({
        format: this.format,
        viewMode: "decades",
      });
    } else {
      $(this.$refs.picker).datetimepicker({
        format: this.format,
      });
    }

    if (this.isPrefillDisabled) {
      this.disableAutoComplete();
    }

    $(this.$refs.picker).on("input.datetimepicker", (e) => {
      this.model = e.target.value;
    });

    if (this.isExpDate) {
      this.$root.$on("updateExpirationDate", (val) => {
        this.model = val;
      });
    }

    this.selectAllData();
  },
  methods: {
    focusUp() {
      this.zindex = true;
    },
    focusDown() {
      this.zindex = false;
    },
    show() {
      this.focusOn = true;
      $(this.$refs.picker).datetimepicker("show");
    },
    hide() {
      $(this.$refs.picker).datetimepicker("hide");
      this.focusOn = false;
    },
    disableAutoComplete() {
      let elements = document.querySelectorAll('[autocomplete="off"]');

      if (!elements) {
        return;
      }

      elements.forEach((element) => {
        element.setAttribute("readonly", "readonly");

        setTimeout(() => {
          element.removeAttribute("readonly");
        }, 500);
      });
    },
    checkModel(event) {
      let model = this.model.split("-").filter((item) => item),
        date = new Date(),
        currentMonth = date.getMonth() + 1,
        that = this;

      let updateDate = new Promise(function (resolve, reject) {
        if (!that.timepicker) {
          if (model.length && model.length < 3) {
            if (model[0] && model.length < 2) {
              that.model =
                model[0] +
                "-" +
                (currentMonth < 10 ? "0" + currentMonth : currentMonth) +
                "-" +
                date.getFullYear();
            } else if (model[1]) {
              that.model = model[0] + "-" + model[1] + "-" + date.getFullYear();
            }

            resolve(that.model);
          }
        }
      });

      if (this.isUpdateExpDate) {
        updateDate.then(() => {
          window.app.methods.updateExpirationDate
            ? window.app.methods.updateExpirationDate()
            : window.pageMethods.updateExpirationDate();
        });
      }
    },
    selectAllData() {
      const selector = this.$refs.picker;

      selector.addEventListener("focus", function () {
        selector.select();
      });
    },
  },
  mixins: [field],
  props: {
    decades: false,
    format: {
      default: "DD-MM-YYYY",
      type: String,
    },
    id: {
      default: "",
      type: String,
    },
    isPrefillDisabled: {
      default: false,
      type: Boolean,
    },
    isExpDate: {
      default: false,
      type: Boolean,
    },
    isUpdateExpDate: {
      default: false,
      type: Boolean,
    },
    timepicker: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style>
.bootstrap-datetimepicker-widget table td.active,
.bootstrap-datetimepicker-widget table td span.active {
  background-color: #26a69a;
}

.bootstrap-datetimepicker-widget table td.active:hover {
  background-color: #006c5f;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/admin/components/VDatepicker.vue